<template>
  <div id="app">
    <!-- <div id="login-bg"></div> -->
    <div class="login-bg-box">
      <div class="login-container">
        <p class="title-text">欢迎登录</p>
        <div class="input-item-container">
            <mds-icon type="fill-user" />
          <input
            type="text"
            @keyup="inputChange('username')"
            placeholder="请输入用户名"
            v-model="username" />
        </div>
        <div class="input-item-container">
          <mds-icon type="fill-padlock" />
          <input
            type="password"
            @keyup="inputChange('password')"
            placeholder="请输入密码"
            v-model="password" />
        </div>
        <div class="verify-code-container">
          <input
            @keyup="inputChange('verify')"
            type="text"
            class="verify-code"
            placeholder="请输入验证码"
            v-model="verifyCode" />
          <img id="VerifyCode" :src="getVerifyCodeSrc" alt="">
          <div @click="verifyCodeImgRefresh()">
            <mds-icon type="line-rotate" />
          </div>
        </div>
        <p v-if="errorType" class="error-info">{{errorType === 'verify' ? '图形验证码错误，请重新输入' : '用户名或密码错误,请重新输入'}}</p>
        <mds-button type="primary" @click="login()" :disabled="!username || !password || !verifyCode || !agreeProtocalCheck">登录</mds-button>
        <div class="remember-pwd-conatiner">
          <mds-checkbox :checked="rememberNamePwd"  @change="rememberNamePwdChange">记住密码</mds-checkbox>
        </div>
        <div class="connect-text">客服热线（周一至周五 9:00-18:00）</div>
        <div class="connect-phone-num">400-620-6688</div>
      </div>
    </div>
    <div class="login-bottom-container">
      <div class="links">
        <a href="https://kfzx.anjuke.com/faqDetail/queryDetail?faqId=95&faqTypeId=11" target="_blank" rel="nofollow">联系我们</a>&nbsp;&nbsp;|&nbsp;&nbsp;
        <a href="https://kfzx.anjuke.com/faqDetail/queryDetail?faqId=188&faqTypeId=10" target="_blank" rel="nofollow">用户协议</a>&nbsp;&nbsp;|&nbsp;&nbsp;
        <a href="https://kfzx.anjuke.com/" target="_blank" rel="nofollow">使用帮助</a>&nbsp;&nbsp;|&nbsp;&nbsp;
        <a href="https://www.anjuke.com/sitemap/" target="_blank" rel="nofollow">网站地图</a>&nbsp;&nbsp;|&nbsp;&nbsp;
        <a href="https://www.anjuke.com/fang/" target="_blank" rel="nofollow">最新房源</a>&nbsp;&nbsp;|&nbsp;&nbsp;
        <a href="https://www.anjuke.com/wenti/" target="_blank" rel="nofollow">最新问答</a>&nbsp;&nbsp;|&nbsp;&nbsp;
        <a href="http://www.anjuke.com/calculator/loan" target="_blank" rel="nofollow">房贷计算器</a>
      </div>
      <div class="copyright">客服热线: 400-620-6688 邮箱:<a class="divSevice" href="mailto:service@58.com">service@58.com</a> 虚假信息举报: 400-620-6688</div>
      <div class="copyright">Copyright © 2007-2025 www.anjuke.com  All Rights Reserved <a href="http://www.miibeian.gov.cn/">ICP号：沪 B2-20090008</a></div>
    </div>
  </div>
</template>

<script>
import $api from './request/index.ts'
import { Base64 } from 'js-base64'
import './assets/style/index.less'
import {hexMd5} from './utils/md5'
import {getCookie, setCookie} from './utils/base'

export default {
  components: {

  },
  name: 'App',
  data() {
    return {
      rememberNamePwd: true,
      username: '',
      password: '',
      verifyCode: '',
      errorType: '', // userpwd | verify
      getVerifyCodeSrc: '/api/auth/getVerifyCode',
      agreeProtocalCheck: true
    }
  },
  async created() {

  },
  mounted() {
    this.namePwdCheckRewrite()
  },
  methods: {
    async login() {
      const params = {
        name: this.username,
        passwd: hexMd5(this.password),
        ivCode: this.verifyCode
      }
      try {
        await $api['global/login'](params)
        this.rememberNamePwdCheck()
        setTimeout(() => {
          window.location.href = '/joint_sales/home'
        }, 100)
      } catch (error) {
        console.log(error)
        if (+error.code === 401) {
          this.errorType = 'userpwd'
        }
        if (+error.code === 400) {
          this.errorType = 'verify'
        }
        this.verifyCodeImgRefresh()
      }
    },
    verifyCodeImgRefresh() {
      const img = document.getElementById('VerifyCode')
      img.src = this.getVerifyCodeSrc + '?rnd=' + Math.random()
    },
    inputChange(type) {
      console.log(type)
      if (type === 'verify' && this.errorType === 'verify') {
        this.errorType = ''
      }
      if ((type === 'username' || type === 'password') && this.errorType === 'userpwd') {
        this.errorType = ''
      }
    },
    rememberNamePwdCheck() {
      if (this.rememberNamePwd) {
        setCookie(['username', this.username, { expires: 7 }])
        setCookie(['assoiejsaodid', Base64.encode(this.password), { expires: 7 }])
      }
    },
    namePwdCheckRewrite() {
      const username = getCookie('username')
      const pwdCookie = getCookie('assoiejsaodid')
      if (!username || !pwdCookie) {
        return
      }
      const pwd = Base64.decode(pwdCookie)
      this.username = username
      this.password = pwd
    },
    agreeProtocalCheckChange(checked) {
      this.agreeProtocalCheck = checked
    },
    rememberNamePwdChange(checked) {
      this.rememberNamePwd = checked
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue